import { Link } from 'react-router-dom'
import { DashBoardLink } from '../Helper/config'
import './BottomBar.css'

const BottomBar = () => {
    return (
        <div style={{ marginTop: "40px" }} className='bottombar-component'>
            <nav className="navbar navbar-expand fixed-bottom navbar-light bg-light bottom-nav py-1">
                <div className="container">
                    <ul className="navbar-nav w-100 justify-content-between">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">
                                <i className="fa fa-house" style={{ color: '#ff9800' }}></i> Home
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/all-recipes">
                                <i className="fa fa-utensils" style={{ color: '#4caf50' }}></i> Recipes
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/all-food">
                                <i className="fa fa-apple-alt" style={{ color: '#e91e63' }}></i> Foods
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to={`/my-orders`}>
                                <i className="fa fa-receipt" style={{ color: '#2196f3' }}></i> Orders
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default BottomBar